
//#region Libraries
import styled from "styled-components";
//#endregion

export const EventGraphicImg = styled.img` 
    box-sizing: border-box;
    background-color: var(--light-blue-2);
    padding: 10px 15px; 
    height: 80px;
    border-radius: 4px;
`;